var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"fixed-bottom-left-button",class:`fixed-bottom-left-button--${_vm.color}`},_vm.$listeners),[_c('span',{staticClass:"material-icons fixed-bottom-left-button__icon",class:{ 'fixed-bottom-left-button__icon--large': _vm.largeIcon }},[_vm._v(_vm._s(_vm.icon))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }